/**
 * Onde moram, na NOSSA origem, os arquivos que o efeito de fundo da câmera carrega. O pacote do LiveKit baixaria o
 * WebAssembly do MediaPipe do jsDelivr e o modelo de segmentação do Google; aqui os dois saem do próprio app: a
 * chamada não depende de terceiros no ar, e nenhum código de fora roda na origem da plataforma.
 *
 * Sem dependências: este arquivo também é lido pelo Vite (`vite.mediapipe-assets.js`), que serve o WebAssembly a
 * partir do `node_modules` no dev e o grava no `dist` no build. A versão está no caminho porque o nginx guarda
 * `.js` e `.wasm` por um ano: trocar a versão do `@mediapipe/tasks-vision` sem trocar o caminho deixaria os navegadores
 * com o arquivo velho (o build recusa essa troca esquecida, e há um teste para o mesmo).
 */
export const MEDIAPIPE_VERSION = '0.10.14';

/** Os arquivos de `@mediapipe/tasks-vision/wasm` que o navegador pede (com e sem SIMD). */
export const MEDIAPIPE_WASM_FILES = Object.freeze([
    'vision_wasm_internal.js',
    'vision_wasm_internal.wasm',
    'vision_wasm_nosimd_internal.js',
    'vision_wasm_nosimd_internal.wasm',
]);

export const MEDIAPIPE_WASM_PATH = `/vendor/mediapipe/wasm/${MEDIAPIPE_VERSION}`;

/** O modelo `selfie_segmenter` (float16, Apache-2.0) fica versionado em `public/vendor/mediapipe/models`. */
export const SEGMENTER_MODEL_PATH = '/vendor/mediapipe/models/selfie_segmenter-float16.tflite';

/** O `assetPaths` do `BackgroundProcessor` do LiveKit. */
export const BACKGROUND_ASSET_PATHS = Object.freeze({
    tasksVisionFileSet: MEDIAPIPE_WASM_PATH,
    modelAssetPath: SEGMENTER_MODEL_PATH,
});
